var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 8.95817C10.3445 8.95817 10.6243 9.23799 10.6243 9.58317V13.7498C10.6243 14.095 10.3445 14.3748 9.99935 14.3748C9.65417 14.3748 9.37435 14.095 9.37435 13.7498V9.58317C9.37435 9.23799 9.65417 8.95817 9.99935 8.95817Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4258 5.78435C10.6824 6.01526 10.7032 6.41045 10.4722 6.66701L10.4639 6.67627C10.233 6.93284 9.83781 6.95364 9.58125 6.72273C9.32468 6.49182 9.30388 6.09664 9.53479 5.84007L9.54312 5.83081C9.77404 5.57424 10.1692 5.55344 10.4258 5.78435Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 2.2915C5.74215 2.2915 2.29102 5.74264 2.29102 9.99984C2.29102 14.257 5.74215 17.7082 9.99935 17.7082C14.2565 17.7082 17.7077 14.257 17.7077 9.99984C17.7077 5.74264 14.2565 2.2915 9.99935 2.2915ZM1.04102 9.99984C1.04102 5.05229 5.0518 1.0415 9.99935 1.0415C14.9469 1.0415 18.9577 5.05229 18.9577 9.99984C18.9577 14.9474 14.9469 18.9582 9.99935 18.9582C5.0518 18.9582 1.04102 14.9474 1.04102 9.99984Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckCircle);
export default __webpack_public_path__ + "static/media/white-check-circle.58b4950504a2b94a7340bdb6e8796e42.svg";
export { ForwardRef as ReactComponent };